import { styled } from '@mui/material/styles';
import { TableContainer as MuiTableContainer, TableBody as MuiTableBody, Typography } from '@mui/material';

const TableContainer = styled(MuiTableContainer)(({ theme }) => ({
    paddingTop: theme.spacing(2),
}));

const TableBody = styled(MuiTableBody)(({ theme }) => ({
    '& tr': {
      lineHeight: theme.spacing(1),
    },
    '& td': {
      verticalAlign: 'top',
      border: `1px solid ${theme.palette.divider}`,
      fontSize: theme.typography.body2.fontSize,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
}));

const Intro = styled(Typography)(({ theme }) => ({
    marginTop: theme.spacing(3),
}));

export { TableContainer, TableBody, Intro };
